<msf-list-page-wrapper [leftSize]="'9'" [rightSize]="'3'" [rightBackground]="true">

  <div left #left>
    <div class="gis-page">
      <p-toast></p-toast>

      <div class="page-header">
        <h1 class="page-title">
          <app-back-button
            [title]="getRegionPathString()"
            parentRoute="/crop-identification"
          ></app-back-button>
        </h1>
      </div>

      <div class="map-wrapper">
        <div class="map-container"
             [class.drawing-mode]="currentDrawingState.isDrawing && currentDrawingState.drawingType === 'polygon'">
          <div class="fields-summary-header">
            <span>{{ 'FIELDS_COUNT' | translate }}: <strong>{{ totalRecords() }}</strong></span>
          </div>
          <!-- OpenStreetMap Component -->
          <app-openstreetmap
            #openstreetmapComponent
            style="width: 100%;"
            [mapController$]="mapController$"
            [mapOptions]="mapOptions"
          ></app-openstreetmap>

          @if (panelOptions.crops) {
            <div class="map-monitoring-control">
              <button
                class="monitoring-btn"
                type="button"
                title="{{ 'MONITORING_POINTS' | translate }}"
                (click)="showCropIdentificationPanel = true">
                <img src="assets/icons/main/light/electronic-fields.svg" width="40" height="40"
                     alt="Monitoring Points">
              </button>
            </div>
          }
          <!--          -->

          @if (showCropIdentificationPanel) {
            <div class="crop-identification-panel" [ngStyle]="cropPanelStyle">
              <div class="crop-panel-header">
                <h3>{{ 'CROP_IDENTIFICATION' | translate }}</h3>
                <button class="close-btn" (click)="showCropIdentificationPanel = false">
                  <i class="pi pi-times"></i>
                </button>
              </div>
              <div class="crop-panel-content">
                @for (crop of getCropIdentificationList(); track crop.nameKey) {
                  <div class="crop-item">
                    <div class="crop-color" [style.background-color]="crop.color"
                         [style.border]="crop.color === '#FFFFFF' ? '1px solid #e5e7eb' : 'none'"></div>
                    <span class="crop-name">{{ crop.nameKey | translate }}</span>
                  </div>
                }
              </div>
            </div>
          }

        </div>
      </div>
    </div>
  </div>


  <div right #right>

    <app-import-field-modal
      [(visible)]="showImportModal"
    ></app-import-field-modal>

    <msf-filters
      [fields]="filtersForms"
      [(ngModel)]="filterModel"
      (clearFilter)="clearFilters()"
      [metaData]="filterMetaData"
      (applyFilter)="applyFilters(filterModel)"
      [export]="true"
      (exportChange)="export()"
    ></msf-filters>
  </div>

</msf-list-page-wrapper>

<app-export-dialog
  [(visible)]="showModalExport"
  [filtersParams]="filtersParams"
  [service]="exportService()"
  [exportMethod]="exportMethod()"
  [exportCsvMethod]="exportCsvMethod()"
></app-export-dialog>

